<template>
	<div class="cbs-date-range-picker flex flex-wrap">
		<div class="w-full sm:flex-1 sm:mr-3 mb-3 sm:mb-0">
			<legend>{{ fromLabel }}</legend>
			<vx-input-group>
				<template slot="append">
					<div class="append-text">
						<i class="nucleo nucleo-calendar-date" @click="triggerClickDatetimePicker('fromDatePickerRef')"></i>
					</div>
				</template>

				<cbs-date-picker
					class="w-full"
					ref="fromDatePickerRef"
					v-bind="$attrs"
					:value="value[0]"
					:placeholder="fromPlaceholder"
					:pickerOptions="pickerFromDateOptions"
					@input="val => $emit('change', [val, value[1]])"
				/>
			</vx-input-group>
		</div>

		<div class="w-full sm:flex-1">
			<legend>{{ toLabel }}</legend>
			<vx-input-group>
				<template slot="append">
					<div class="append-text">
						<i class="nucleo nucleo-calendar-date" @click="triggerClickDatetimePicker('toDatePickerRef')"></i>
					</div>
				</template>

				<cbs-date-picker
					class="w-full"
					ref="toDatePickerRef"
					v-bind="$attrs"
					:value="value[1]"
					:placeholder="toPlaceholder"
					:pickerOptions="pickerToDateOptions"
					@input="val => $emit('change', [value[0], val])"
				/>
			</vx-input-group>
		</div>
	</div>
</template>

<script>
import _ from "lodash";
import moment from "moment";

export default {
	name: "CbsDateRangePicker",
	inheritAttrs: false,
	props: {
		value: {
			type: Array,
			required: true,
			validator: prop => {
				if (!_.isEmpty(prop)) {
					if (prop.length !== 2) {
						return false;
					}
				}
				return true;
			}
		},
		fromLabel: {
			type: String
		},
		toLabel: {
			type: String
		},
		fromPlaceholder: {
			type: String,
			default: "FromDate"
		},
		toPlaceholder: {
			type: String,
			default: "ToDate"
		}
	},
	computed: {
		pickerToDateOptions() {
			return { disabledDate: this.setDisableToDate };
		},
		pickerFromDateOptions() {
			return { disabledDate: this.setDisableFromDate };
		}
	},
	methods: {
		setDisableFromDate(date) {
			if (this.value && this.value[1]) {
				return moment(date).isAfter(moment(this.value[1]));
			}
			return false;
		},
		setDisableToDate(date) {
			if (this.value && this.value[0]) {
				return moment(date).isBefore(moment(this.value[0]));
			}
			return false;
		},
		triggerClickDatetimePicker(ref) {
			this.$refs[ref].$children[0].pickerVisible = true;
		}
	}
};
</script>

<style lang="scss" scoped>
.cbs-date-range-picker {
	.vx-input-group-append {
		background-color: white;
	}
}
</style>